import React, { useState } from 'react';
import { Alert, Button } from '@statsbomb/kitbag-components';
import { FormattedMessage, useIntl } from 'react-intl';
import useApi, { API_ENDPOINTS } from '../../hooks/api';
import Confirm from '../Confirm';

export function EmptyQueue() {
  const api = useApi();
  const intl = useIntl();

  const [message, setMessage] = useState('');
  const [displayConfirmation, setDisplayConfirmation] = useState(false);

  const emptyQueue = async () => {
    await api.delete(`${API_ENDPOINTS.videoService}/downloads?purge_all=True`);
    setMessage(
      intl.formatMessage({
        defaultMessage: 'Emptying of Queue Initiated',
        id: 'fe8d3',
      }),
    );
    setDisplayConfirmation(false);
  };

  const handleClick = () => setDisplayConfirmation(true);

  return (
    <>
      <Button onClick={handleClick} isPending={api.isFetching}>
        <FormattedMessage defaultMessage="Empty Queue" id="c86dd" />
      </Button>
      {(message || api.errorMessage) && (
        <Alert type={api.errorMessage && 'error'}>
          {api.errorMessage || message}
        </Alert>
      )}
      <Confirm
        id="empty-queue"
        isOpen={displayConfirmation}
        onCancel={() => setDisplayConfirmation(false)}
        onConfirm={emptyQueue}
      >
        <FormattedMessage
          defaultMessage="This will remove all download requests which could include those submitted by customers"
          id="dac07"
        />
      </Confirm>
    </>
  );
}

export default { EmptyQueue };
